<template>
    <Select :options="areas.values.map(a => ({
            html: a.name,
            value: a.id
        }))" 
        :value='f.id'
        @update:value='updateValue'
        
        menuMaxHeight='324px'
    />

    <!-- lat_lng -->
    <!-- <div class='w-full h-[300px] overflow-hidden mt-4'>
        <div class='w-[140%] h-[140%] m-[-20%]'>
            <GoogleMap
                v-if='value != null && value.length > 0'
                ref="map"
                :subscription='{
                    location_area: f
                }'
            />
        </div>
    </div> -->
</template>

<script>
    import GoogleMap from '~/components/customer/blocks/google-map-old.vue'

    export default {
        props: ['areas', 'page', 'value'],

        computed: {
            f() {
                if (this.value == null || this.value.length == 0) {
                    return { id: null }
                }

                return this.areas.values.find(a => a.id == this.value[0])
            }
        },

        methods: {
            updateValue(value) {
                this.page.user.filters.location = [value]
                this.page.call().updated()
            }
        },

        components: {
            GoogleMap
        }
    }
</script>